import PropTypes from "prop-types"
import { Autocomplete, TextField, Checkbox, Button, Box } from "@mui/material"
import { DROPDOWN_OPTION } from "helpers/shapes"
import { isEmpty } from "lodash"

export default function MultiSelectFilter({ values, options, setValues, disabled }) {
  const handleSetValues = (_, newValues) => {
    setValues(...newValues)
  }

  const CustomListbox = (props) => {
    return (
      <>
        <Box sx={{ pt: 1, px: 1 }}>
          {!isEmpty(values) && (
            <Button
              className="multi-select-clear-all-button"
              size="small"
              variant="text"
              color="primary"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSetValues(null, [])}
            >
              Clear All
            </Button>
          )}
        </Box>
        <ul {...props} />
      </>
    )
  }

  return (
    <Autocomplete
      options={options}
      value={values}
      multiple
      disabled={disabled}
      onChange={handleSetValues}
      disableCloseOnSelect
      disableClearable
      isOptionEqualToValue={(option, value) => option.value === value.value}
      slotProps={{
        chip: { size: "small" },
        listbox: {
          component: CustomListbox,
        },
        popper: {
          sx: {
            minWidth: "fit-content",
          },
          placement: "bottom-start",
        },
      }}
      renderOption={({ key, ...props }, option, { selected }) => {
        return (
          <li key={key} {...props}>
            <Checkbox
              style={{ marginRight: 8 }}
              checked={selected}
              size="small"
            />
            {option.label}
          </li>
        )
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
        />
      )}
    />
  )
}

MultiSelectFilter.propTypes = {
  values: PropTypes.arrayOf(DROPDOWN_OPTION).isRequired,
  options: PropTypes.arrayOf(DROPDOWN_OPTION).isRequired,
  setValues: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
